(function () {
  if (window.__cartDrawerFixInitialized) return;
  window.__cartDrawerFixInitialized = true;

  let isUpdating = false;
  let updateQueued = false;
  let quantityUpdateInProgress = false;

  function syncThemeCart(cart) {
    if (typeof MinimogTheme !== 'undefined' && MinimogTheme.Cart) {
      MinimogTheme.Cart.cart = cart;
      if (typeof MinimogTheme.Cart.updateCartCount === 'function') {
        MinimogTheme.Cart.updateCartCount(cart);
      }
    }
  }

  function getTotalQuantity(cart) {
    if (!cart?.items?.length) return 0;
    return cart.items.reduce((sum, item) => sum + item.quantity, 0);
  }

  function updateHeaderCartCounts(cart) {
    if (!cart) return;

    const lineCount = cart.item_count ?? 0;
    const totalQty = getTotalQuantity(cart);

    document.querySelectorAll('.sf-cart-count').forEach((el) => {
      el.textContent = lineCount;
      el.setAttribute('data-count', lineCount);
      el.style.display = lineCount > 0 ? '' : 'none';
    });

    const cartCountHeader = document.querySelector('.scd__header h3');
    if (cartCountHeader) {
      cartCountHeader.textContent = `MY CART (${totalQty})`;
    }

    const emptyMessage = document.querySelector('.scd-empty-msg');
    const itemsContainer = document.querySelector('.scd__items');
    const cartDrawerFooter = document.querySelector('.scd__footer');

    if (lineCount === 0) {
      emptyMessage?.classList.remove('hidden');
      if (emptyMessage) emptyMessage.style.display = 'block';
      itemsContainer?.classList.add('hidden');
      if (itemsContainer) itemsContainer.style.display = 'none';
      cartDrawerFooter?.classList.add('hidden');
      if (cartDrawerFooter) cartDrawerFooter.style.display = 'none';
    } else {
      emptyMessage?.classList.add('hidden');
      if (emptyMessage) emptyMessage.style.display = 'none';
      itemsContainer?.classList.remove('hidden');
      if (itemsContainer) itemsContainer.style.display = 'block';
      cartDrawerFooter?.classList.remove('hidden');
      if (cartDrawerFooter) cartDrawerFooter.style.display = 'block';
    }
  }

  function openCartDrawerFallback() {
    const cartDrawer = document.querySelector('.scd__wrapper');
    const cartDrawerContent = document.querySelector('.scd__content');
    if (!cartDrawer || !cartDrawerContent) return false;

    if (window.innerWidth < 770) {
      document.documentElement.classList.add('prevent-scroll');
      cartDrawer.classList.add('mobile');
    }

    cartDrawer.classList.remove('hidden');
    cartDrawer.style.setProperty('--tw-bg-opacity', '0.5');
    cartDrawerContent.classList.remove('translate-x-full');
    return true;
  }

  function openCartDrawer() {
    const cart = MinimogTheme?.Cart;
    if (cart?.openCartDrawer && cart.enableCartDrawer !== false && cart.domNodes?.cartDrawer) {
      cart.openCartDrawer();
    }
    openCartDrawerFallback();
  }

  function startAtcLoader() {
    document.querySelectorAll('form[data-type="add-to-cart-form"], product-form form').forEach((form) => {
      form.classList.add('adding', 'cart-atc-pending');
    });
  }

  function stopAtcLoader() {
    document.querySelectorAll('form.cart-atc-pending').forEach((form) => {
      form.classList.remove('adding', 'cart-atc-pending');
    });
  }

  function showItemAddedNotification() {
    const cart = MinimogTheme?.Cart;
    const message = window.MinimogStrings?.itemAdded;
    if (!cart?.domNodes?.cartDrawerItems || !message || !MinimogTheme?.Notification) return;

    MinimogTheme.Notification.show({
      target: cart.domNodes.cartDrawerItems,
      method: 'prepend',
      type: 'success',
      message,
      delay: 400,
    });
  }

  function setDrawerLoading(isLoading) {
    const body = document.querySelector('.scd__body');
    if (body) body.classList.toggle('scd__body--loading', isLoading);
  }

  async function fetchCartSectionHtml() {
    const response = await fetch(`/?section_id=cart-drawer&_=${Date.now()}`, {
      cache: 'no-store',
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.text();
  }

  async function fetchCartSectionRoot(fresh = false) {
    if (!fresh && MinimogTheme?.Cart?.fetchCartSection) {
      return MinimogTheme.Cart.fetchCartSection();
    }
    const html = await fetchCartSectionHtml();
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = html;
    return tempContainer;
  }

  function syncCartDomNodes() {
    const cart = MinimogTheme?.Cart;
    const drawer = document.querySelector('.scd__wrapper');
    if (!cart?.domNodes || !drawer) return;

    cart.domNodes.cartDrawer = drawer;
    cart.domNodes.cartDrawerContent = drawer.querySelector('.scd__content');
    cart.domNodes.cartDrawerItems = drawer.querySelector('.scd__items');
    cart.domNodes.cartDrawerFooter = drawer.querySelector('.scd__footer');
  }

  function applyCartDrawerFromRoot(root, cart) {
    if (cart) updateHeaderCartCounts(cart);

    const newHeader = root.querySelector('.scd__header');
    const currentHeader = document.querySelector('.scd__header');
    if (newHeader && currentHeader) currentHeader.innerHTML = newHeader.innerHTML;

    const newBody = root.querySelector('.scd__body');
    const currentBody = document.querySelector('.scd__body');
    if (newBody && currentBody) currentBody.innerHTML = newBody.innerHTML;

    const newSummary = root.querySelector('.scd__summary');
    const currentSummary = document.querySelector('.scd__summary');
    if (newSummary && currentSummary) currentSummary.innerHTML = newSummary.innerHTML;

    const newFooter = root.querySelector('.scd__footer');
    const currentFooter = document.querySelector('.scd__footer');
    const lineCount = cart?.item_count ?? 0;
    if (newFooter && currentFooter) {
      currentFooter.innerHTML = newFooter.innerHTML;
      if (lineCount > 0) {
        currentFooter.classList.remove('hidden');
        currentFooter.style.display = 'block';
      } else {
        currentFooter.classList.add('hidden');
        currentFooter.style.display = 'none';
      }
    }

    syncCartDomNodes();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  }

  async function updateCartDrawerSection(existingCart) {
    if (!document.querySelector('.scd__wrapper')) return;

    let cart = existingCart;
    if (!cart) {
      cart = await fetch('/cart.js').then((r) => r.json());
      syncThemeCart(cart);
    }

    const root = await fetchCartSectionRoot(true);
    applyCartDrawerFromRoot(root, cart);
  }

  async function updateCartDrawerContent(existingCart) {
    if (isUpdating) {
      updateQueued = true;
      return;
    }

    isUpdating = true;

    try {
      if (!document.querySelector('.scd__wrapper')) return;

      let cart = existingCart;
      let sectionRoot;

      if (cart) {
        syncThemeCart(cart);
        sectionRoot = await fetchCartSectionRoot(true);
      } else {
        const [fetchedCart, root] = await Promise.all([
          fetch('/cart.js').then((r) => r.json()),
          fetchCartSectionRoot(true),
        ]);
        cart = fetchedCart;
        syncThemeCart(cart);
        sectionRoot = root;
      }

      applyCartDrawerFromRoot(sectionRoot, cart);
    } catch (error) {
      console.error('Error updating cart drawer:', error);
    } finally {
      isUpdating = false;
      if (updateQueued) {
        updateQueued = false;
        updateCartDrawerContent();
      }
    }
  }

  function wrapShopifyOnItemAdded() {
    if (typeof Shopify === 'undefined' || typeof Shopify.onItemAdded !== 'function') return;
    if (Shopify.onItemAdded.__cartDrawerFixWrapped) return;

    const originalOnItemAdded = Shopify.onItemAdded;
    Shopify.onItemAdded = async function (lineItem, openDrawer) {
      const shouldOpen = openDrawer !== false;
      startAtcLoader();

      try {
        if (shouldOpen) {
          openCartDrawer();
          setDrawerLoading(true);
        }

        await originalOnItemAdded.call(this, lineItem, false);

        let cart = MinimogTheme?.Cart?.cart;
        if (!cart) {
          cart = await fetch('/cart.js').then((r) => r.json());
        }
        syncThemeCart(cart);
        updateHeaderCartCounts(cart);

        await updateCartDrawerSection(cart);

        if (shouldOpen) {
          openCartDrawer();
          showItemAddedNotification();
        }
      } catch (error) {
        console.error('Error refreshing cart drawer after add:', error);
        if (shouldOpen) openCartDrawer();
      } finally {
        setDrawerLoading(false);
        stopAtcLoader();
      }
    };
    Shopify.onItemAdded.__cartDrawerFixWrapped = true;
  }

  async function changeCartQuantity(itemKey, newQty) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: newQty }),
    });
    if (!response.ok) throw new Error('Failed to update cart');
    return response.json();
  }

  function blockThemeQtyHandlers(event) {
    const inDrawerItem = event.target.closest('.scd__wrapper .scd-item');
    if (!inDrawerItem) return false;

    const isQty = event.target.closest('.scd-item__btn');
    const isRemove = event.target.closest('.scd-item__remove');
    if (!isQty && !isRemove) return false;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return true;
  }

  async function handleQuantityClick(button) {
    if (quantityUpdateInProgress || button.disabled) return;

    const item = button.closest('.scd-item');
    const input = item?.querySelector('.scd-item__qty_input');
    if (!item || !input) return;

    const qtyChange = button.dataset.qtyChange;
    const isIncrement = qtyChange === 'inc' || button.textContent.trim() === '+';
    const isDecrement = qtyChange === 'dec' || button.textContent.trim() === '-';
    if (!isIncrement && !isDecrement) return;

    const currentQty = parseInt(input.value, 10) || 0;
    const newQty = isIncrement ? currentQty + 1 : Math.max(1, currentQty - 1);
    if (newQty === currentQty) return;

    const itemKey = item.dataset.id;
    if (!itemKey) return;

    quantityUpdateInProgress = true;
    button.classList.add('loading');
    button.disabled = true;

    try {
      const cart = await changeCartQuantity(itemKey, newQty);
      syncThemeCart(cart);
      updateHeaderCartCounts(cart);
      await updateCartDrawerContent(cart);
      if (typeof MinimogEvents !== 'undefined') {
        MinimogEvents.emit('ON_CART_UPDATE', cart);
      }
    } catch (error) {
      console.error('Error updating quantity:', error);
      input.value = currentQty;
    } finally {
      quantityUpdateInProgress = false;
      button.classList.remove('loading');
      button.disabled = false;
    }
  }

  async function handleRemoveClick(removeButton) {
    if (quantityUpdateInProgress || removeButton.disabled) return;

    const item = removeButton.closest('.scd-item');
    const itemKey = item?.dataset.id;
    if (!item || !itemKey) return;

    quantityUpdateInProgress = true;
    removeButton.classList.add('loading');
    removeButton.disabled = true;

    try {
      const cart = await changeCartQuantity(itemKey, 0);
      syncThemeCart(cart);
      updateHeaderCartCounts(cart);
      await updateCartDrawerContent(cart);
      if (typeof MinimogEvents !== 'undefined') {
        MinimogEvents.emit('ON_CART_UPDATE', cart);
      }
    } catch (error) {
      console.error('Error removing item:', error);
    } finally {
      quantityUpdateInProgress = false;
      removeButton.classList.remove('loading');
      removeButton.disabled = false;
    }
  }

  function init() {
    wrapShopifyOnItemAdded();

    document.addEventListener(
      'click',
      (event) => {
        if (!blockThemeQtyHandlers(event)) return;

        const qtyButton = event.target.closest('.scd-item__btn');
        if (qtyButton) {
          handleQuantityClick(qtyButton);
          return;
        }

        const removeButton = event.target.closest('.scd-item__remove');
        if (removeButton) handleRemoveClick(removeButton);
      },
      true
    );

    if (typeof MinimogEvents !== 'undefined') {
      MinimogEvents.subscribe('ON_ITEM_ADDED', () => {
        startAtcLoader();
      });

      MinimogEvents.subscribe('ON_CART_UPDATE', (cart) => {
        if (cart) {
          syncThemeCart(cart);
          updateHeaderCartCounts(cart);
        }
      });
    }

    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        syncThemeCart(cart);
        updateHeaderCartCounts(cart);
      })
      .catch(console.error);

    const waitForCartDrawer = setInterval(() => {
      if (document.querySelector('.scd__wrapper')) {
        clearInterval(waitForCartDrawer);
        updateCartDrawerContent();
      }
    }, 100);
    setTimeout(() => clearInterval(waitForCartDrawer), 10000);
  }

  window.__refreshCartDrawer = updateCartDrawerContent;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(wrapShopifyOnItemAdded, 300);
  setTimeout(wrapShopifyOnItemAdded, 1000);
})();
